import {forEach as _forEach, join as _join} from 'lodash';
import {keyboardMap, keyboardModifiers, consumerMap, genericMap} from './hid';

class FlircFileException {
    constructor(message) {
        this.message = message;
    }
}

class FlircConfigFile {
    constructor(arrayBufferWrapper) {
        this.parseHeader(arrayBufferWrapper);
        this.parseSettings(arrayBufferWrapper);
        this.parsePatterns(arrayBufferWrapper);
    }

    parseHeader(arrayBufferWrapper) {};
    parseSettings(arrayBufferWrapper) {};
    parsePatterns(arrayBufferWrapper) {};
    getRomTables(val) {};
    getKeyDescription(reportId, modifier, key) {};
}

class FlircConfigFileV1_0 extends FlircConfigFile {
    parseHeader(arrayBufferWrapper) {
        this.header = {
            magic: arrayBufferWrapper.getUInt32(),
            version: [
                arrayBufferWrapper.getUInt16(),
                arrayBufferWrapper.getUInt16(),
            ],
            size: arrayBufferWrapper.getUInt32(),
            crc: arrayBufferWrapper.getUInt32(),
        };
    };

    parseSettings(arrayBufferWrapper) {
        this.settings = {
            romtables: this.getRomTables(arrayBufferWrapper.getUInt32()),
            timing: arrayBufferWrapper.getUInt32(),
            general: arrayBufferWrapper.getUInt32(),
        };
    };

    parsePatterns(arrayBufferWrapper) {
        this.patterns = [];
        for (let i = 0; i < this.header.size; i++) {
            let pattern = {
                hash: arrayBufferWrapper.getUInt32(),
                timeElapsed: arrayBufferWrapper.getUInt32(),
                next: arrayBufferWrapper.getUInt32(),
                longPress: arrayBufferWrapper.getUInt8(),
                reportId: arrayBufferWrapper.getUInt8(),
                modifier: arrayBufferWrapper.getUInt8(),
                key: arrayBufferWrapper.getUInt8(),
            };
            pattern.desc = this.getKeyDescription(pattern.reportId, pattern.modifier, pattern.key);
            this.patterns.push(pattern);
        }
    };

    getRomTables(val) {
        return [
            ['Fire TV', (val & 0x01) !== 0],
            ['Kodi', (val & 0x02) !== 0],
            ['Microsoft WMC', (val & 0x04) !== 0],
            ['Flirc WMC', (val & 0x08) !== 0],
            ['NVIDIA Shield', (val & 0x10) !== 0],
        ]
    }

    getKeyDescription(reportId, modifier, key) {
        if (reportId === 1) {
            let keys = [];
            _forEach(keyboardModifiers, ([bit, name]) => {
                if ((modifier & bit) > 0) {
                    keys.push(name);
                }
            });
            if (key !== 0) {
                keys.push(keyboardMap[key] || 'Unknown');
            }
            return _join(keys, ' + ');
        } else if (reportId === 2) {
            return consumerMap[modifier] || 'Unknown';
        } else if (reportId === 3) {
            switch (modifier) {
                case 1:
                    return genericMap[0x82];
                case 2:
                    return genericMap[0x81];
                case 3:
                    return genericMap[0x83];
                default:
                    return 'Unknown';
            }
        } else if (reportId === 4) {
            switch (modifier) {
                case 0x01:
                    return consumerMap[0xcd];
                case 0x02:
                    return consumerMap[0x183];
                case 0x04:
                    return consumerMap[0xb5];
                case 0x08:
                    return consumerMap[0xb6];
                case 0x10:
                    return consumerMap[0xea];
                case 0x20:
                    return consumerMap[0x223];
                case 0x40:
                    return consumerMap[0x225];
                case 0x80:
                    return consumerMap[0x224];
                default:
                    return 'Unknown';
            }
        } else {
            return 'Unknown';
        }
    }
}

class FlircConfigFactory {
    static MAGIC = 0xDEADBEEF;

    static flircConfigVersions = [
        [1, 0, FlircConfigFileV1_0],
    ];

    static parse = (arrayBuffer) => {
        const d = new ArrayBufferWrapper(arrayBuffer);
        if (d.getUInt32() !== FlircConfigFactory.MAGIC) {
            throw new FlircFileException("Not a Flirc config file.");
        }

        let major = d.getUInt16();
        let minor = d.getUInt16();

        let cls = null;
        _forEach(FlircConfigFactory.flircConfigVersions, ([_mjr, _mnr, _cls], idx) => {
            if (_mjr > major) {
                return false;
            } else if (_mjr === major && _mnr > minor) {
                return false;
            } else {
                cls = _cls;
            }
        });
        if (cls === null) {
            throw  new FlircFileException("Not a supported config version.");
        }
        d.seek(0);
        return new cls(d);
    }
}

class ArrayBufferWrapper {
    constructor(arrayBuffer) {
        this.arrayBuffer = arrayBuffer;
        this.offset = 0;
    }

    seek(offset, seekorigin='begin') {
        switch (seekorigin) {
            case 'current':
                this.offset += offset;
                break;
            case 'end':
                this.offset = this.arrayBuffer.length - offset;
                break;
            default:
                this.offset = offset;
        }
    }

    getUInt8() {
        return new Uint8Array(this.arrayBuffer, this.offset++, 1)[0];
    }

    getUInt16() {
        let r = new Uint16Array(this.arrayBuffer, this.offset, 1)[0];
        this.offset += 2;
        return r;
    }

    getInt16() {
        let r = new Int16Array(this.arrayBuffer, this.offset, 1)[0];
        this.offset += 2;
        return r;
    }

    getUInt32() {
        let r = new Uint32Array(this.arrayBuffer, this.offset, 1)[0];
        this.offset += 4;
        return r;
    }

    getInt32() {
        let r = new Int32Array(this.arrayBuffer, this.offset, 1)[0];
        this.offset += 4;
        return r;
    }
}

export {
    FlircConfigFile,
    FlircConfigFactory,
    ArrayBufferWrapper,
}



// WEBPACK FOOTER //
// ./src/utils.js